import { useState, useCallback } from "react";

function useDisclosure({
  defaultIsOpen = false,
  onOpen: onOpenProp,
  onClose: onCloseProp,
  onToggle: onToggleProp,
} = {}) {
  const [isOpen, setIsOpen] = useState(defaultIsOpen);

  const onOpen = useCallback(() => {
    setIsOpen(true);
    if (onOpenProp) {
      onOpenProp();
    }
  }, [onOpenProp]);

  const onClose = useCallback(() => {
    setIsOpen(false);
    if (onCloseProp) {
      onCloseProp();
    }
  }, [onCloseProp]);

  const onToggle = useCallback(() => {
    setIsOpen((prev) => {
      const newState = !prev;
      if (onToggleProp) {
        onToggleProp(newState);
      }
      return newState;
    });
  }, [onToggleProp]);

  const getButtonProps = useCallback(
    (props = {}) => ({
      ...props,
      onClick: onToggle,
    }),
    [onToggle]
  );

  const getDisclosureProps = useCallback(
    (props = {}) => ({
      ...props,
      id: "disclosure-content",
      open: isOpen,
      onClose: onClose,
    }),
    [isOpen, onClose]
  );

  return {
    isOpen,
    onOpen,
    onClose,
    onToggle,
    getButtonProps,
    getDisclosureProps,
  };
}

export default useDisclosure;
